/**
 * Xuất bảng ra CSV — văn bản thuần, mọi phần mềm đọc được.
 *
 * LỊCH SỬ: ban đầu chỉ có CSV. Lý do là hệ thống cũ dùng SheetJS để ghi .xlsx
 * và kéo một thư viện ~1 MB vào gói giao diện chỉ để xuất bảng là cái giá đáng
 * kể cho mọi lần tải trang. Lý do đó không còn: exceljs đã vào gói cho PI, báo
 * giá, hoá đơn, và từ 16/09/2026 nút Xuất dùng chung cho chọn Excel (.xlsx,
 * mặc định) hoặc CSV — xem `exportXlsx.ts`. CSV giữ lại cho người nạp dữ liệu
 * vào phần mềm khác: có BOM UTF-8 nên Excel vẫn mở thẳng, giữ nguyên tiếng
 * Việt có dấu và tiếng Trung, và dán được vào Google Sheets.
 *
 * KHÁC BIỆT THỰC SỰ, nói rõ để không ai tưởng là tương đương: CSV không có
 * nhiều sheet trong một file, không định dạng ô, không công thức. Bản kê công
 * nợ ba sheet vì thế chỉ có bản Excel (`statementSheets.ts`); trước 16/09/2026 nó
 * từng được tải thành ba tệp CSV.
 */
import { toCsv, type CsvColumn } from "@hisense/shared";
export { toCsv, type CsvColumn };

/**
 * Tải một chuỗi CSV về máy.
 *
 * BOM UTF-8 (﻿) là bắt buộc: thiếu nó, Excel trên Windows đọc file theo
 * bảng mã địa phương và mọi ký tự tiếng Việt/tiếng Trung thành rác. Đây là lý
 * do phổ biến nhất khiến "xuất Excel" bị coi là hỏng.
 */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([`﻿${csv}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Thu hồi ở lần lặp sau: thu hồi ngay lập tức làm hỏng tải file trên Safari.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function exportCsv<T>(filename: string, columns: CsvColumn<T>[], rows: readonly T[]): void {
  downloadCsv(filename, toCsv(columns, rows));
}

/** Ngày cho tên file: 2026-09-01, sắp xếp được theo thứ tự chữ cái. */
export function fileStamp(d = new Date()): string {
  return [d.getFullYear(), d.getMonth() + 1, d.getDate()]
    .map((n, i) => (i ? String(n).padStart(2, "0") : String(n)))
    .join("-");
}
